import React from 'react';

export default () => (
  <div className="form-group">
    <span className="required">* Required Information</span>
  </div>
);
